/** Place catalog changed on this device or via Firestore snapshot. */
export const MENU_UPDATED_EVENT = 'wortelogy-menu-updated'
export const TABLES_UPDATED_EVENT = 'wortelogy-tables-updated'
export const FLOOR_UPDATED_EVENT = 'wortelogy-floor-updated'
export const QR_CODES_UPDATED_EVENT = 'wortelogy-qr-codes-updated'
export const SETTINGS_CHANGED_EVENT = 'wortelogy-settings-changed'

export function dispatchCatalogEvent(name: string): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(name))
}
